import * as React from 'react';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { AllowedDataHandler } from '../../models/ResearchOrderModel';
import { FormFieldString, FormFieldProps, FormField } from 'sos-common/js/commonTypes/formField.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { getErrorMessageByFieldName } from '../../utilities/helpers';

export interface AllowedDataHndlrItem extends AllowedDataHandler {
    id: number;
}
export interface AllowedDataHandlerItemProps extends FormFieldProps<AllowedDataHndlrItem> {
  value: AllowedDataHndlrItem;
  namePlaceholder: string;
  organisationPlaceholder: string;
  index: number;
  validationResults: ValidationResult[];
  onBlur(): void;
  hasHitSummary?: boolean;
}

interface AllowedDataHandlerItemState extends FormField<AllowedDataHndlrItem> {
  nameTouched: boolean;
  titleTouched: boolean;
}

export default class AllowedDataHandlerItem extends React.Component<AllowedDataHandlerItemProps, AllowedDataHandlerItemState> {
  constructor(props: any) {
    super(props);
    const {fieldName} = this.props;
    this.state = {
      nameTouched: false,
      titleTouched: false,
      fieldName,
      value: {
        Name: this.props.value.Name || '',
        Title: this.props.value.Title || '',
        id: this.props.value.id || 0,
        FieldName: this.props.value.FieldName || ''
      }
    };
  }

  handleOnChange = () => {
      this.props.onChange(this.state);
  }
  onChangeName = (field: FormFieldString) => {
    this.setState(state => {
        return {
          ...state,
          value: {
            ...state.value,
            Name: field.value,
            id: this.props.index
          },
          nameTouched: true
        }
    }, this.handleOnChange)
  }

  onChangeTitle = (field: FormFieldString) => {
    this.setState(state => {
        return {...state,
          value: {
            ...state.value,
            Title: field.value,
            id: this.props.index
          },
          titleTouched: true
        }
    },this.handleOnChange)
  }

  handleOnBlur = () => {
    this.props.onBlur();
  }

  public render() {
    const { namePlaceholder, organisationPlaceholder, index, validationResults } = this.props;
    const {Name, Title} = this.state.value;
    return (
      <div className="sos-textinput">
        <TextInput
          fieldName={`CurrentResearchOrder.Security.AllowedDataHandlers[${index}].Name`}
          placeholder={namePlaceholder}
          onChange={this.onChangeName}
          value={Name}
          maxLength={160}
          onBlur={this.handleOnBlur}
          errorMessage={(this.state.nameTouched || this.props.hasHitSummary) ? getErrorMessageByFieldName(validationResults, `CurrentResearchOrder.Security.AllowedDataHandlers[${index}].Name`) : ''}
          label={namePlaceholder}
          labelClass='sr-only'
          isRequired={true}
          autoComplete="name"
        />
        <TextInput
          fieldName={`CurrentResearchOrder.Security.AllowedDataHandlers[${index}].Title`}
          placeholder={organisationPlaceholder}
          onChange={this.onChangeTitle}
          value={Title}
          maxLength={160}
          onBlur={this.handleOnBlur}
          errorMessage={(this.state.titleTouched || this.props.hasHitSummary) ? getErrorMessageByFieldName(validationResults, `CurrentResearchOrder.Security.AllowedDataHandlers[${index}].Title`) : ''}
          label={organisationPlaceholder}
          labelClass='sr-only'
          isRequired={true}
          autoComplete="organization"
        />
      </div>
    );
  }
}
